var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('ol',{staticClass:"gradient-list"},[_c('h1',[_vm._v("Lessons")]),_vm._l((_vm.lessons),function(lesson,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":{
          name: 'show',
          params: {
            lessonId: lesson._id,
            slideId: lesson.slides[lesson.position],
          },
        }}},[_vm._v(" "+_vm._s(lesson.title)+" ")])],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }